import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, newId } from '../api.js';
import { ErrorBox, JobPage } from '../components.jsx';

const MESSAGES = {
  name_required: 'Please enter their name.',
  phone_or_email_required: 'Please enter a phone number or an email address.',
  bad_email: "That email address doesn't look right.",
  network: 'No signal – nothing was saved. Try again when you have signal.',
};

function Field({ label, children }) {
  return (
    <div>
      <label className="label">{label}</label>
      {children}
    </div>
  );
}

function Form({ job }) {
  const nav = useNavigate();
  const [sid] = useState(newId);
  const [f, setF] = useState({ name: '', phone: '', email: '', title: '' });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const [dupes, setDupes] = useState(null);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  async function submit(extra = {}) {
    setBusy(true);
    setError(null);
    try {
      await api.post(`/api/jobs/${job.id}/contacts`, { sid, ...f, ...extra });
      nav(`/job/${job.id}/done?what=contact`, { replace: true });
    } catch (e) {
      if (e.message === 'auth_required') return;
      if (e.data?.error === 'duplicate') setDupes(e.data.duplicates);
      else setError(MESSAGES[e.data?.error] || MESSAGES[e.message] || "Couldn't save the contact. Please try again.");
      setBusy(false);
    }
  }

  if (dupes) {
    return (
      <div className="space-y-4">
        <div className="card p-4">
          <p className="font-bold">This person might already be in the CRM</p>
          {dupes.length === 0 && <p className="mt-1 text-steel">Someone with the same details exists.</p>}
        </div>
        {dupes.map((d) => (
          <button key={d.id} className="btn-primary w-full" disabled={busy} onClick={() => submit({ useExistingId: d.id })}>
            Yes – use {d.name}
          </button>
        ))}
        <button className="btn-ghost w-full" disabled={busy} onClick={() => submit({ skipDuplicateCheck: true })}>No – add {f.name} as a new person</button>
        <button className="w-full py-2 text-steel underline" onClick={() => setDupes(null)}>Go back</button>
        {error && <ErrorBox>{error}</ErrorBox>}
      </div>
    );
  }

  return (
    <form className="space-y-4" onSubmit={(e) => { e.preventDefault(); submit(); }}>
      <Field label="Name">
        <input className="input" autoComplete="off" autoCapitalize="words" value={f.name} onChange={set('name')} placeholder="First and last name" required />
      </Field>
      <Field label="Mobile">
        <input className="input" type="tel" inputMode="tel" autoComplete="off" value={f.phone} onChange={set('phone')} placeholder="04xx xxx xxx" />
      </Field>
      <Field label="Email">
        <input className="input" type="email" inputMode="email" autoComplete="off" autoCapitalize="none" value={f.email} onChange={set('email')} />
      </Field>
      <Field label="Their role (optional)">
        <input className="input" autoComplete="off" value={f.title} onChange={set('title')} placeholder="e.g. Site manager" />
      </Field>
      {error && <ErrorBox>{error}</ErrorBox>}
      <button className="btn-primary w-full" disabled={busy || !f.name.trim()}>{busy ? 'Saving…' : 'Save contact'}</button>
    </form>
  );
}

export default function AddContact() {
  return <JobPage title="Add a contact">{(job) => <Form job={job} />}</JobPage>;
}
